__turbopack_context__.v({
  "icon": "TopicLead-module-scss-module__RsVJOG__icon",
});
